
class CartOptionsPrice {

    static generateId(){
        // unique id to match with the main product - used for validation and update of quantity changes
        return Date.now().toString();
    }

    static getItem(id){
        // parse item if not yet in storage
        if(!CartOptionsPrice.storage.hasOwnProperty(id)){
            CartOptionsPrice.storage[id] = CartOptionsPrice.parseItem(id);
        }

        return CartOptionsPrice.storage[id];
    }

    static storeItem(id, item){

        CartOptionsPrice.storage[id] = item;

        if(window.localStorage){
            localStorage.setItem(CartOptionsPrice.keyPrefix + id, JSON.stringify(item));
        }
    }

    static parseItem(id){
        if(window.localStorage){
            let itemJson = localStorage.getItem(CartOptionsPrice.keyPrefix +id);
            if(itemJson){
                return JSON.parse(itemJson);
            }
        }
        return {};
    }
}

CartOptionsPrice.storage = {};
CartOptionsPrice.keyPrefix = 'cl_'

export default CartOptionsPrice;